package com.vamvisions.main.portfolio.presentation.common

import com.vamvisions.main.core.domain.DataError
import com.vamvisions.main.core.domain.Result
import com.vamvisions.main.core.domain.preferences.Language
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

/**
 * Loads a page's content in the active language. Starting a load cancels the one in flight, so a slow
 * response in the previous language can never overwrite the new one. [retry] repeats the last load.
 */
class LanguageLoader<T>(
    private val scope: CoroutineScope,
    private val fetch: suspend (Language) -> Result<T, DataError.Network>,
    private val onStart: () -> Unit,
    private val onResult: (Language, Result<T, DataError.Network>) -> Unit,
) {
    private var language: Language? = null
    private var job: Job? = null

    /** Loads in [language], unless that language is already loaded or loading. */
    fun languageChanged(language: Language) {
        if (language == this.language) return
        this.language = language
        load(language)
    }

    fun retry() {
        language?.let(::load)
    }

    private fun load(language: Language) {
        job?.cancel()
        job = scope.launch {
            onStart()
            onResult(language, fetch(language))
        }
    }
}
